import rgba from '../functions/rgba';
import pxToRem from '../functions/pxToRem';
import { pxToEm } from '../functions/pxToEm';

export const colorValues = {
    accent1: {
        '50': '#F5F3FF',
        '100': '#ECE9FE',
        '200': '#DDD6FE',
        '300': '#C3B5FD',
        '400': '#A48AFB',
        '500': '#875BF7',
        '600': '#7839EE',
        '700': '#6927DA',
        '800': '#5720B7',
        '900': '#491C96',
        '950': '#2E125E',
    },
    accent2: {
        '50': '#EFF6FF',
        '100': '#DBEAFE',
        '200': '#BFDBFE',
        '300': '#93C5FD',
        '400': '#60A5FA',
        '500': '#3B82F6',
        '600': '#2563EB',
        '700': '#1D4ED8',
        '800': '#1E40AF',
        '900': '#1E3A8A',
        '950': '#172554',
    },
    alpha: {
        white: {
            '100': rgba('#FFFFFF', 0.1),
            '200': rgba('#FFFFFF', 0.2),
            '300': rgba('#FFFFFF', 0.3),
            '400': rgba('#FFFFFF', 0.4),
            '500': rgba('#FFFFFF', 0.5),
            '600': rgba('#FFFFFF', 0.6),
            '700': rgba('#FFFFFF', 0.7),
            '800': rgba('#FFFFFF', 0.8),
            '900': rgba('#FFFFFF', 0.9),
            '950': rgba('#FFFFFF', 0.95),
            '1000': rgba('#FFFFFF', 1),
        },
    },
    attention: {
        '50': '#FEFCE8',
        '100': '#FEF9C3',
        '200': '#FEF08A',
        '300': '#FDE047',
        '400': '#FACC15',
        '500': '#EAB308',
        '600': '#A16207',
        '700': '#A16207',
        '800': '#854D0E',
        '900': '#713F12',
        '950': '#422006',
    },
    critical: {
        '50': '#FFF1F2',
        '100': '#FFE4E6',
        '200': '#FECDD3',
        '300': '#FDA4AF',
        '400': '#FB7185',
        '500': '#F43F5E',
        '600': '#E11D48',
        '700': '#BE123C',
        '800': '#9F1239',
        '900': '#881337',
        '950': '#4C0519',
    },
    neutral: {
        '0': '#FFFFFF',
        '50': '#F5F5F5',
        '100': '#F2F2F3',
        '200': '#E4E4E7',
        '300': '#D4D4D8',
        '400': '#A1A1AA',
        '500': '#71717A',
        '600': '#52525B',
        '700': '#3F3F46',
        '800': '#27272A',
        '900': '#18181B',
        '950': '#09090B',
    },
    success: {
        '50': '#ECFDF5',
        '100': '#D1FAE5',
        '200': '#A7F3D0',
        '300': '#6EE7B7',
        '400': '#34D399',
        '500': '#10B981',
        '600': '#059669',
        '700': '#047857',
        '800': '#065F46',
        '900': '#064E3B',
        '950': '#022C22',
    },
};

export const uphealOSColorValues = {
    accent1: {
        '50': '#F5F3FF',
        '100': '#ECE9FE',
        '200': '#DDD6FE',
        '300': '#C3B5FD',
        '400': '#A48AFB',
        '500': '#875BF7',
        '600': '#7839EE',
        '700': '#6927DA',
        '800': '#5720B7',
        '900': '#491C96',
        '950': '#2E125E',
    },
    accent2: {
        '50': '#EFF6FF',
        '100': '#DBEAFE',
        '200': '#BFDBFE',
        '300': '#93C5FD',
        '400': '#60A5FA',
        '500': '#3B82F6',
        '600': '#2563EB',
        '700': '#1D4ED8',
        '800': '#1E40AF',
        '900': '#1E3A8A',
        '950': '#172554',
    },
    alpha: {
        white: {
            '100': rgba('#FFFFFF', 0.1),
            '200': rgba('#FFFFFF', 0.2),
            '300': rgba('#FFFFFF', 0.3),
            '400': rgba('#FFFFFF', 0.4),
            '500': rgba('#FFFFFF', 0.5),
            '600': rgba('#FFFFFF', 0.6),
            '700': rgba('#FFFFFF', 0.7),
            '800': rgba('#FFFFFF', 0.8),
            '900': rgba('#FFFFFF', 0.9),
            '950': rgba('#FFFFFF', 0.95),
            '1000': rgba('#FFFFFF', 1),
        },
    },
    attention: {
        '50': '#FEFCE8',
        '100': '#FEF9C3',
        '200': '#FEF08A',
        '300': '#FDE047',
        '400': '#FACC15',
        '500': '#EAB308',
        '600': '#A16207',
        '700': '#A16207',
        '800': '#854D0E',
        '900': '#713F12',
        '950': '#422006',
    },
    critical: {
        '50': '#FFF1F2',
        '100': '#FFE4E6',
        '200': '#FECDD3',
        '300': '#FDA4AF',
        '400': '#FB7185',
        '500': '#F43F5E',
        '600': '#E11D48',
        '700': '#BE123C',
        '800': '#9F1239',
        '900': '#881337',
        '950': '#4C0519',
    },
    neutral: {
        '0': '#191933',
        '50': '#232347',
        '100': '#2D2D5B',
        '200': '#3A3C66',
        '300': '#4D4F7A',
        '400': '#6B6D92',
        '500': '#8688A8',
        '600': '#9D94B8',
        '700': '#A2A3C0',
        '800': '#C7C7DC',
        '900': '#E8E8F0',
        '950': '#F5F5FA',
    },
    success: {
        '50': '#ECFDF5',
        '100': '#D1FAE5',
        '200': '#A7F3D0',
        '300': '#6EE7B7',
        '400': '#34D399',
        '500': '#10B981',
        '600': '#059669',
        '700': '#047857',
        '800': '#065F46',
        '900': '#064E3B',
        '950': '#022C22',
    },
};

export const avatarAccentValues = {
    accent1: { fg: '#7839EE', bg: '#F5F3FF', border: '#DDD6FE' },
    accent2: { fg: '#2563EB', bg: '#EFF6FF', border: '#BFDBFE' },
    accent3: { fg: '#BF3A9F', bg: '#FEF5FD', border: '#F9D5F4' },
    accent4: { fg: '#10838E', bg: '#ECFFFE', border: '#A6FBF9' },
    accent5: { fg: '#15801C', bg: '#F0FDF0', border: '#B1F6B4' },
    accent6: { fg: '#C05836', bg: '#FCF6F0', border: '#EED1BA' },
    accent7: { fg: '#89701F', bg: '#FAFBEB', border: '#E8EC9C' },
    accent8: { fg: '#667FC5', bg: '#F1F8FC', border: '#D2E4F3' },
    accent9: { fg: '#5F911F', bg: '#F6FBEA', border: '#D4EEA8' },
    accent10: { fg: '#93653B', bg: '#F8F5EE', border: '#DDCEAB' },
} as const;

export const borderRadiusValues = {
    ['radius-0']: '0px',
    ['radius-2']: '2px',
    ['radius-4']: '4px',
    ['radius-6']: '6px',
    ['radius-8']: '8px',
    ['radius-10']: '10px',
    ['radius-12']: '12px',
    ['radius-16']: '16px',
    ['radius-20']: '20px',
    ['radius-24']: '24px',
    ['radius-32']: '32px',
    ['radius-full']: '9999px',
};

export const spacingValues = {
    none: '0px',
    xxs: '2px',
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '10px',
    xl: '12px',
    '2xl': '16px',
    '3xl': '20px',
    '4xl': '24px',
    '5xl': '32px',
    '6xl': '40px',
    '7xl': '48px',
} as const;

export const iconSizingValues = {
    xxs: '8px',
    xs: '12px',
    sm: '16px',
    md: '20px',
    lg: '24px',
    xl: '28px',
    '2xl': '32px',
} as const;

export const fontWeightValues = {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
} as const;

export const focusWidthValues = {
    md: '2px',
} as const;

export const fontSizeValues = {
    h1: pxToRem(56),
    h2: pxToRem(48),
    h3: pxToRem(40),
    h4: pxToRem(32),
    h5: pxToRem(24),
    h6: pxToRem(20),
    xl: pxToRem(24),
    lg: pxToRem(18),
    md: pxToRem(16),
    sm: pxToRem(14),
    xs: pxToRem(12),
    xxs: pxToRem(11),
};

export const lineHeightValues = {
    h1: pxToRem(64),
    h2: pxToRem(56),
    h3: pxToRem(48),
    h4: pxToRem(40),
    h5: pxToRem(28),
    h6: pxToRem(28),
    xl: pxToRem(32),
    lg: pxToRem(28),
    md: pxToRem(24),
    sm: pxToRem(20),
    xs: pxToRem(16),
    xxs: pxToRem(12),
};

export const letterSpacingValues = {
    h1: pxToEm(-1.68, 56),
    h2: pxToEm(-0.96, 48),
    h3: pxToEm(-0.8, 40),
    h4: pxToEm(-0.32, 32),
    h5: 'inherit',
    h6: 'inherit',
    xl: 'inherit',
    lg: 'inherit',
    md: 'inherit',
    sm: 'inherit',
    xs: 'inherit',
    xxs: 'inherit',
};
